module.exports = __webpack_public_path__ + "img/服务行业.5d884d8c.png";